module.exports = __webpack_public_path__ + "media/images/sp/stores/shinjuku/shinjuku_sns_05-0277b294fdf086bcf92c90e89a5c81dc.jpg";